<template>
  <base-content class="flex-column">
    <div class="d-flex">
      <button type="button" class="text-left btn btn-link py-0 pl-0 mb-2" @click="$router.back()"><fa class="mr-1 small my-auto" icon="chevron-left"></fa>Back</button>
    </div>
    <div class="h5 mb-3">Payment Methods</div>
    <div class="card-deck">
      <div class="card shadow-sm">
        <div class="card-header bg-white">
          <div class="d-flex justify-content-between">
            <h6 class="my-auto">ACH Bank Account</h6>
          </div>
        </div>
        <div class="card-body">
          <BankAccount :businessId="businessId" @updated="$router.back()" />
        </div>
      </div>
      <div class="card shadow-sm">
        <div class="card-header bg-white">
          <div class="d-flex justify-content-between">
            <h6 class="my-auto">Debit/Credit Card</h6>
          </div>
        </div>
        <div class="card-body">
          <CreditCard :businessId="businessId" @updated="$router.back()" />
        </div>
      </div>
    </div>
  </base-content>
</template>

<script>
import CreditCard from "@/components/CreditCard/CreditCard.vue";
import BankAccount from "@/components/BankAccount/BankAccount.vue";

export default {
  components: {
    CreditCard,
    BankAccount,
  },
  props: {
    businessId: String,
  },
};
</script>
